import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=c297ffd4&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c297ffd4')) {
      api.createRecord('c297ffd4', component.options)
    } else {
      api.reload('c297ffd4', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=c297ffd4&", function () {
      api.rerender('c297ffd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2D7JXo05vHXns/JS/ImageCarousel.vue"
export default component.exports